
import Editor from '@/components/editor/index.vue'
import CoverUpload from '@/components/cover_upload/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { CommonService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { IMG_HOST } from '@/config/env'
import { parseTime } from '@/common/utils'

const validator = {
    required: true,
    message: '该项为必填项/必选项',
    trigger: 'blur'
}

type Pannel = 'data' | 'flow' | 'api'

@Component({
    name: 'institute-create',
    components: {
        Editor,
        CoverUpload
    }
})
export default class extends Vue {
    @Prop({ default: 'data' }) private type!: Pannel
    @Ref('formRef') private formEl!: ElForm
    @Ref('fileRef') private fileEl!: any

    private typeList: any[] = []
    private institute: any = {
        title: '',
        created_at: '',
        url: '',
        type_id: -1,
        abstract: '',
        content: '',
        organization: '牛媒',
        writer: 'mediabeer',
        cover_img: '',
        recommend: 0,
        top: 0
    }
    private recommendTotal = 0
    private topTotal = 0
    private rules = {}
    private createLoading = false
    created() {
        this.generateValidator()
    }
    async mounted() {
        this.institute.type_id = +this.$route.query.id
        await this.fetchTypeData()
        await this.getArticles()
        await this.getArticles(true)
    }
    async fetchTypeData() {
        const result = await CommonService.getIArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
            if (this.institute.type_id === -1) {
                this.institute.type_id = result.data[0].id
            }
        }
    }

    async getArticles(top = false) {
        const params = { }
        top && Object.assign(params, { top: 1 })
        !top && Object.assign(params, { recommend: 1, type_id: this.institute.type_id || undefined })
        const result = await CommonService.getIArticleList(params)
        if (result.status === 200) {
            if (top) {
                this.topTotal = result.data.page_total
            } else {
                this.recommendTotal = result.data.page_total
            }
        }
    }

    generateValidator() {
        const optionalFields = ['abstract', 'url', 'organization', 'writer']
        const rules: Record<string, any> = {}
        Reflect.ownKeys(this.institute).forEach(key => {
            if (key === 'cover_img') {
                rules[key as string] = [{ validator: this.imageValidator }]
            } else if (key === 'url') {
                rules[key as string] = [{ type: 'url', message: '请输入正确的链接', trigger: 'blur' }]
            } else if (key === 'abstract') {
                rules[key as string] = [{ max: 300, message: '最多不能超过300字', trigger: 'blur' }]
            } else if (optionalFields.includes(key as string)) {
                rules[key as string] = [{ ...validator, required: false }]
            } else {
                rules[key as string] = [validator]
            }
        })
        this.rules = rules
    }

    onCreate() {
        this.formEl.validate(async (valid: boolean) => {
            if (!valid) return
            if (typeof this.institute.cover_img === 'object') {
                const result = await new UploadImg(this.institute.cover_img).upload()
                if (result.error) {
                    return this.$merror('发生错误, 图片上传失败, 请稍后再试')
                }
                this.institute.cover_img = IMG_HOST + result.key
            }
            this.onCreateData()
        })
    }

    imageValidator(rules: any, value: any, callback: Function) {
        callback()
    }
    onCoverChange() {
        this.institute.cover_img = (this.$refs.coverUpload as any).getFile()
    }
    onRichTextChange(content: string) {
        this.institute.content = content
    }
    private async onCreateData() {
        this.createLoading = true
        this.institute.created_at = parseTime(this.institute.created_at)
        const result = await CommonService.createIArticle({ ...this.institute })
        this.createLoading = false
        if (result.status === 200) {
            return this.$msuccess('创建成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    async onRecommendChange() {
        if (this.institute.recommend) {
            if (this.recommendTotal >= 5) {
                this.$confirm('当前每个类型仅支持添加5篇推荐文章，请先移出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const url = '/setting/institute/top/list'
                    window.open(url)
                })
                this.institute.recommend = 0
            } else {
                this.recommendTotal += 1
            }
        }
    }

    async onTopChange() {
        if (this.institute.top) {
            if (this.topTotal >=6) {
                this.$confirm('当前仅支持添加6篇置顶文章，请先移出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const url = '/setting/institute/top/list'
                    window.open(url)
                })
                this.institute.top = 0
            } else {
                this.topTotal += 1
            }
        }
    }

    onTypeChange() {
        this.getArticles()
    }
}
